import {ReactElement, ChangeEvent, useMemo} from 'react';
import classNames from 'classnames';
import LockIconSvg from '../LockIconSvg';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  type?: 'text' | 'password' | 'email' | 'number' | 'tel';
  labelClassName?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
}

export default function InputField({
  name,
  value,
  onChange,
  type = 'text',
  labelClassName,
  label,
  placeholder,
  required = false,
  error,
  ...props
}: InputFieldProps): ReactElement {
  const hasError = useMemo(() => !!error, [error]);

  return (
    <label
      className={labelClassName}
      style={{display: props.hidden ? 'none' : 'block'}}
    >
      {label && (
        <span>
          {label}
          {props?.disabled && <LockIconSvg />}
        </span>
      )}
      <input
        type={type}
        className={classNames('form__element', {
          'form__element-error': hasError,
        })}
        placeholder={placeholder || ''}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        {...props}
      />
      {hasError && <p className="error-msg">{error}</p>}
    </label>
  );
}
